// src/components/FaunaRace/FaunaBackground.js
import React, { useEffect, useRef } from 'react';
import styles from './FaunaRace.module.css';

// --- Konfigurasi Latar Belakang ---
const DECORATIONS_CONFIG = [
    { emojis: ['🌿', '🌸', '🍀', '🌻', '🌷'], count: 5, type: 'silhouette' },
    // PERBAIKAN: Tambah jumlah serangga agar lebih ramai
    { emojis: ['🦋', '🐞', '🐝', '🐛'], count: 10, type: 'creature' },
    // PERBAIKAN: Tambah jumlah daun yang melayang
    { emojis: ['🍃', '🍂'], count: 6, type: 'drifter' },
];
const VINE_COUNT = 15;

const random = (min, max) => Math.random() * (max - min) + min;

function FaunaBackground() {
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container || container.childElementCount > 0) return;

        DECORATIONS_CONFIG.forEach(group => {
            for (let i = 0; i < group.count; i++) {
                const el = document.createElement('div');
                el.className = styles.decoration;
                el.textContent = group.emojis[Math.floor(random(0, group.emojis.length))];

                el.style.left = `${random(5, 95)}%`;
                el.style.top = `${random(5, 95)}%`;
                el.style.fontSize = `clamp(${random(20, 50)}px, ${random(4, 10)}vw, ${random(70, 120)}px)`; // Sedikit lebih kecil agar tidak terlalu mendominasi
                el.style.zIndex = Math.random() > 0.5 ? -1 : -2;
                
                switch (group.type) {
                    case 'silhouette':
                        el.style.opacity = '0.1';
                        el.style.filter = 'blur(2px)';
                        el.style.color = '#1a4d0a';
                        // PERBAIKAN: Durasi animasi lebih cepat
                        el.style.animation = `${styles.floatUp} ${random(8, 15)}s ease-in-out infinite, ${styles.gentleZoom} ${random(7, 12)}s ease-in-out infinite`;
                        break;
                        
                    case 'creature':
                        el.style.opacity = '0.4'; // Sedikit lebih terlihat
                        // PERBAIKAN: Gunakan animasi 'darting' baru untuk beberapa serangga
                        if (Math.random() > 0.5) {
                            el.style.animation = `${styles.darting} ${random(3, 6)}s ease-in-out infinite`;
                        } else {
                            el.style.animation = `${styles.sway} ${random(2, 5)}s ease-in-out infinite alternate`;
                        }
                        break;

                    case 'drifter':
                        el.style.opacity = '0.25';
                        // PERBAIKAN: Durasi animasi melayang lebih cepat
                        el.style.animation = `${styles.driftAcross} ${random(6, 12)}s linear infinite`;
                        el.style.top = `${random(10, 90)}%`; 
                        break;
                        
                    default:
                        break;
                }
                
                // PERBAIKAN: Delay animasi lebih pendek agar gerakan dimulai lebih cepat
                el.style.animationDelay = `${random(0, 5)}s`;

                container.appendChild(el);
            }
        });

        // Buat Sulur Gantung (Vines)
        for (let i = 0; i < VINE_COUNT; i++) {
            const vine = document.createElement('div');
            vine.className = styles.vine;
            vine.style.left = `${random(5, 95)}%`;
            vine.style.height = `${random(15, 40)}%`;
            // PERBAIKAN: Animasi sulur juga dipercepat
            vine.style.animationDelay = `${random(0, 5)}s`;
            vine.style.animationDuration = `${random(4, 8)}s`;
            container.appendChild(vine);
        }

    }, []);

    return <div ref={containerRef} className={styles.backgroundContainer} />;
}

export default React.memo(FaunaBackground);